//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import DonorSpecieDelete from './delete';
import DonorSpecieEdit from './edit';
import DonorSpecie from './list';

export const FilterDonorSpecie = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[2] !== "donor_specie") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterDonorSpecie.Provider value={{ filter, setFilter }}>
      <Route path="/premixlabel/donor_specie" exact component={DonorSpecie} isPrivate/>
      <Route path="/premixlabel/donor_specie/edit/:id" exact component={DonorSpecieEdit} isPrivate/>
      <Route path="/premixlabel/donor_specie/add" exact component={DonorSpecieEdit} isPrivate/>
      <Route path="/premixlabel/donor_specie/delete/:id" exact component={DonorSpecieDelete} isPrivate/>
    </FilterDonorSpecie.Provider>
  )
}  